<template>
  <card title="Tu información">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="update"
      @keydown="form.onKeydown($event)"
    >
      <v-container grid-list-xl>
         <v-layout
              id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.razonSocial"
                  label="Razón Social"
                  :placeholder="razonSocialPlaceholder"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.identificacion"
                  label="Número de Identificación"
                  placeholder="RUC o Cédula"
                  maxlength="20"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.email"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.telefono"
                  label="Teléfono"
                  placeholder="####-#### / ######-####-####"
                  maxlength="16"
                  :readonly="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_province_id"
                  :items="itemsProvince"
                  item-value="id"
                  item-text="name"
                  label="Provincia"
                  :readonly="true"
                  @change="getDistrito()"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_district_id"
                  :items="itemsDistrict"
                  item-value="id"
                  item-text="name"
                  label="Distrito"
                  :readonly="true"
                  @change="getCorregimiento()"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.cat_corregimiento_id"
                  :items="itemsCorregimiento"
                  item-value="id"
                  item-text="name"
                  label="Corregimiento"
                  :readonly="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.direccion"
                  label="Dirección"
                  placeholder="Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá"
                  :readonly="true"
                />
              </v-col>
            </v-layout>
      </v-container>
    </v-form>
  </card>
</template>

<script>
import Form from 'vform';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';

export default {
  directives: {
    mask,
  },
  metaInfo() {
    return this.title;
  },
  data: () => ({
    form: new Form({
      id: '',
      identificacion: '',
      razonSocial: '',
      email: '',
      telefono: '',
      cat_corregimiento_id: '',
      cat_district_id: '',
      cat_province_id: '',
      direccion: '',
      activo: 0,
      busy: false,
    }),
    valid: false,
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    apiURL: '/api/settings/profileDealer',
  }),

  computed: mapGetters({
    user: 'auth/user',
    razonSocialPlaceholder() {
      return process.env.VUE_APP_ENV === 'HKA'
        ? 'The Factory HKA CORP'
        : 'Electronic Business Intelligence en Panamá';
    },
    addressPlaceholder() {
      return process.env.VUE_APP_ENV === 'HKA'
        ? 'Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá'
        : 'Edificio W50, C. 76 Este, Panamá';
    },
  }),

  created() {
    // Fill the form with user data.
    this.form.keys().forEach((key) => {
      this.form[key] = this.user[key];
    });
  },
   watch: {
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
      window.axios.get(`${this.apiURL}`)
      .then((result) => {
        Object.assign(this.form, result.data);
      });
  },

  methods: {
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
          const url = `/api/districts/${this.form.cat_province_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsDistrict = response.data;
        });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
          const url = `/api/corregimientos/${this.form.cat_district_id}`;
          window.axios.get(url)
          .then((response) => {
          this.itemsCorregimiento = response.data;
        });
      }
    },
  },
};
</script>
